import { render, staticRenderFns } from "./FactFindLiabilityOther.vue?vue&type=template&id=436e1826&"
import script from "./FactFindLiabilityOther.vue?vue&type=script&lang=ts&"
export * from "./FactFindLiabilityOther.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports